import { Api } from "@core/api/api";
import { pageParams } from "@core/api/pageParams";
import { Page, PaginationOptions } from "@utils/page";
import { NotificationDto, notificationFromDto } from "./dtos";
import { NotificationFilter, TooshareNotification } from "./notification";

const NOTIFICATION_URL = "/notifications";

export class NotificationApi {
	constructor(private readonly api: Api) {}

	async list(pageOptions: PaginationOptions): Promise<Page<TooshareNotification, { unread: number }>> {
		const result = await this.api.get<Page<NotificationDto, { total_unread: number }>>(
			`${NOTIFICATION_URL}?${pageParams(pageOptions)}`
		);

		return {
			...result.data,
			content: result.data.content.map(notificationFromDto),
			unread: result.data.total_unread,
		};
	}

	read(id: string): Promise<void> {
		return this.api.post(`${NOTIFICATION_URL}/${id}/read`);
	}

	readAll(): Promise<void> {
		return this.api.post(`${NOTIFICATION_URL}/read_all`);
	}

	delete(id: string): Promise<void> {
		return this.api.delete(`${NOTIFICATION_URL}/${id}`);
	}

	async getEnabledSettings(): Promise<Page<NotificationFilter>> {
		const result = await this.api.get<{ enabled: NotificationFilter[] }>(`${NOTIFICATION_URL}/settings`);
		const content = result.data.enabled;
		return {
			page: 0,
			total_pages: 1,
			total_size: content.length,
			content_size: content.length,
			page_size: content.length,
			content: content,
		};
	}

	setEnabledSettings(filter: NotificationFilter, enabled: boolean): Promise<void> {
		return this.api.post(`${NOTIFICATION_URL}/settings`, { ...filter, enabled });
	}

	inviteFriends(emails: string[]): Promise<void> {
		return this.api.post(`/invitations`, { emails });
	}
}
